import React from "react";
import { FIELD_REGISTRY } from "./Config/fieldRegistry"; // <--- ✅ Line 1: Import add karo

function ProductCategoryInformation({
    formData,
    categories,
    subCategories,
    units,
    handleChange,
    setSelectedSubCategory,
    handleCategoryChange,
    setSubCategorySlug,
    errors,
    config
}) {
    const fields = config?.fields?.category || [];
    if (fields.length === 0) return null;

    const handleSubCategoryChange = (e) => {
        const selectedId = e.target.value;
        const selected = subCategories.find(item => String(item.id) === String(selectedId));
        if (selected && setSubCategorySlug) {
            setSubCategorySlug(selected.slug || "");
        }
        handleChange(e);
    };

    return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header">
                <h5>Category Information</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {fields.map((fieldName) => {
                        const fieldConfig = FIELD_REGISTRY[fieldName];
                        if (!fieldConfig) return null;

                        const { type, label, required } = fieldConfig;

                        if (type === 'select') {
                            let options = [];
                            let onChangeHandler = handleChange;
                            let isDisabled = false;

                            if (fieldName === 'category_id') {
                                options = categories;
                                onChangeHandler = handleCategoryChange;
                                isDisabled = !!formData.category_id;
                            } else if (fieldName === 'subcategory_id') {
                                options = subCategories;
                                onChangeHandler = handleSubCategoryChange;
                                isDisabled = !!formData.subcategory_id;
                            } else if (fieldName === 'unit_id') {
                                options = units;
                                isDisabled = false;
                            }

                            return (
                                <div className="col-md-6 mb-3" key={fieldName}>
                                    <label className="form-label">
                                        {label} {required && <span className="text-danger">*</span>}
                                    </label>
                                    <select
                                        className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                        name={fieldName}
                                        value={formData[fieldName] || ""}
                                        onChange={onChangeHandler}
                                        disabled={isDisabled}
                                    >
                                        <option value="">Select {label}</option>
                                        {Array.isArray(options) && options.map((opt) => (
                                            <option key={opt.id || opt.value || opt} value={opt.id || opt.value || opt}>
                                                {opt.name || opt.label || opt}
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.[fieldName] && (
                                        <div className="invalid-feedback">{errors[fieldName]}</div>
                                    )}
                                </div>
                            );
                        }

                        return null;
                    })}
                </div>
            </div>
        </div>
    );
}

export default ProductCategoryInformation;